import React from "react";
import HorizontalScrollerWithViewDetection from "./HorizontalScrollerWithViewDetection";
import styled, { withTheme } from "styled-components";
import Arrow from "./Arrow";
import PropTypes from "prop-types";
import MediaQueryOverride from "../mediaquery/media-query-override";
import { jsQueries } from "../mediaquery/breakpoints";

const BUTTON_WIDTH = 28;
const BUTTON_HEIGHT = 49;

const BaseButton = styled.button`
  filter: drop-shadow(2px 2px 8px rgba(0, 0, 0, 0.6));
  opacity: 1;
  transition: opacity 0.2s, visibility 0.2s;
  visibility: visible;
  background: transparent;
  border: none;
  line-height: 0;
  ${props => props.right && "transform: rotate(180deg);"}

  &:disabled {
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.2s, visibility 0s 0.2s;
  }
`;

function PrevBtn(btnProps) {
  return (
    <BaseButton {...btnProps} type="button">
      <Arrow width={BUTTON_WIDTH} height={BUTTON_HEIGHT} />
    </BaseButton>
  );
}

function NextBtn(btnProps) {
  return (
    <BaseButton {...btnProps} type="button" right>
      <Arrow width={BUTTON_WIDTH} height={BUTTON_HEIGHT} />
    </BaseButton>
  );
}

/**
 * Swimlane mounts all items immediately, but renders them individually
 * via the renderItem prop, which tells you if the item is in view so
 * you can defer parts of the UI initialization until it is actually visible.
 *
 * Swimlane does not size or space any of the items, but merely uses the provided
 * values to calculate which items are in view or not
 *
 * Updating the itemCount at runtime IS supported
 */
function Swimlane({ extraItems = 5, ...rest }) {
  const props = { extraItems, ...rest };
  return (
    <MediaQueryOverride query={jsQueries.small} buttonInset={12}>
      <MediaQueryOverride query={jsQueries.medium} buttonInset={20}>
        <HorizontalScrollerWithViewDetection
          forward={NextBtn}
          back={PrevBtn}
          thumbColor={props.theme.color.secondary.getShade(6)}
          {...props}
        />
      </MediaQueryOverride>
    </MediaQueryOverride>
  );
}

Swimlane.propTypes = {
  // Should return li element with key
  renderItem: PropTypes.func.isRequired,
  // With including spacing!
  averageItemWidth: PropTypes.number.isRequired,
  itemCount: PropTypes.number.isRequired,
  // Arg scroll percent as decimal
  // TODO BUG: Gets called twice with value 0 at start, likely related to initial size setup
  onScroll: PropTypes.func,
  // Get info about the swimlane (such as if it can scroll)
  onInfoChange: PropTypes.func,
  // How many items outside the computed range to flag as in view
  extraItems: PropTypes.number,
  thumbColor: PropTypes.string
};


export default withTheme(Swimlane);
